const containers = document.querySelectorAll('[data-bars]');
containers.forEach(container => {
  const slider = container.querySelector('[data-bars-slider]');
  const prevEl = container.querySelector('[data-bars-slider-prev]');
  const nextEl = container.querySelector('[data-bars-slider-next]');
  const button = container.querySelector('[data-bars-button]');
  const activeSlider = tns({
    edgePadding: 70,
    container: slider,
    mouseDrag: true,
    navPosition: 'bottom',
    navAsThumbnails: true,
    preventScrollOnTouch: 'auto',
    preventActionWhenRunning: true,
    prevButton: prevEl,
    nextButton: nextEl,
    responsive: {
      375: {
        arrows: false,
        edgePadding: 80},
      425: {
        arrows: false,
        edgePadding: 120},
      540: {
        arrows: false,
        edgePadding: 180},
      768: {
        arrows: true,
        items: 5,
        center: true,
        edgePadding: 0
      }
    }
  });

  // initialize the Shop Button
  const sliderInfo = activeSlider.getInfo()
  container.style.backgroundColor = sliderInfo.slideItems[sliderInfo.index].getAttribute('data-item-color')
  button.setAttribute('href', sliderInfo.slideItems[sliderInfo.index].getAttribute('data-item-url'))

  activeSlider.events.on('indexChanged', info => {
    info.slideItems.forEach(slide => slide.classList.remove('active-slide'));
    info.slideItems[info.index].classList.add('active-slide');
    container.style.backgroundColor = info.slideItems[info.index].getAttribute('data-item-color');
    //button.setAttribute('href', `#bars-${info.slideItems[info.index].getAttribute('data-item-id')}`);
    button.setAttribute('href', info.slideItems[info.index].getAttribute('data-item-url'));
  });
});



// Make a toggle
if ( containers.length > 1 ) {
  containers.forEach(container => {
    if ( ! container.classList.contains('toggle-active') ) {
      container.classList.add('d-none')
    }
  })

  document.querySelectorAll(`[data-tab-trigger]`).forEach(toggleBtn => {
    toggleBtn.addEventListener('click', (evt) => {
      evt.preventDefault()

      if (evt.target.classList.contains('active')) {
        return
      }

      // manage toggle buttons status
      const button = evt.target
      const parent = button.parentNode.parentNode
      parent.querySelector(`.toggle.active`).classList.remove('active')

      button.classList.add('active')

      // manage Sliders
      const selectedID = button.dataset.tabTrigger
      containers.forEach(container => {
        const sliderID = container.dataset.bars

        if ( sliderID == selectedID ) {
          container.classList.remove('d-none')
          container.classList.add('toggle-active')
        } else {
          container.classList.add('d-none')
          container.classList.remove('toggle-active')
        }
      })
    })
  })
}